import { Fragment, useCallback, useState } from 'react';
import Player from 'components/player';
import { useEventManipulate } from './useEventManipulate';
import { useParams } from 'react-router-dom';
import PasscodePage from 'components/passcodePage';
import NotFound from 'components/notFound';

import 'styles/scss/routes/embed.scss';
import { useSelector } from 'react-redux';

export default function Embed(props) {
  const params = useParams();
  const { browserSessionIdentifier } = useSelector((state) => state.app);
  const {
    backgroundImage,
    event,
    channel,
    channelId,
    channels,
    isReady,
    isDrm,
    isVod,
    lowLatency,
    customStyle,
    playerProblemHandler,
    displayPasscodePage,
    title,
    passcodeValidating,
    validatePasscodeSuccessHandler,
    audioChangeHandler,
    getDisplayMessage,
    customConfig,
    notFound,
  } = useEventManipulate(props);
  const [userActive, setUserActive] = useState(true);

  const userActiveHandler = useCallback(() => {
    setUserActive(true);
  }, []);

  const userInactiveHandler = useCallback(() => {
    setUserActive(false);
  }, []);

  const wrappedValidatePasscodeSuccessHandler = useCallback(
    (validateResponseData, saveCookies) => {
      validatePasscodeSuccessHandler(validateResponseData, channels, saveCookies);
    },
    [channels, validatePasscodeSuccessHandler]
  );

  return (
    <Fragment>
      {notFound ? (
        <NotFound />
      ) : (
        <main className="embed-page" style={customStyle}>
          {displayPasscodePage() ? (
            <PasscodePage
              eventId={params.eventId}
              title={title()}
              passcodeValidating={passcodeValidating}
              validatePasscodeSuccessHandler={wrappedValidatePasscodeSuccessHandler}
            ></PasscodePage>
          ) : (
            <div className="event-container">
              {channelId && channels && channels.length > 1 && userActive && (
                <div className="active-header">
                  <div className="audio-selector-wrapper">
                    <select
                      className="audio-selector"
                      value={channelId}
                      onChange={(e) => {
                        audioChangeHandler(e.target.value);
                      }}
                    >
                      {channels.map((_channel) => (
                        <option value={_channel.id} key={_channel.id}>
                          {getDisplayMessage(_channel.label, _channel.customLabel)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              <Player
                cmcd={{
                  sessionId: browserSessionIdentifier,
                  contentId: `${params.eventId}/${channel.label}`,
                }}
                channelLabel={channel.label}
                backgroundImage={backgroundImage()}
                hlsPlaybackUrl={channel.hlsPlaybackUrl}
                dashPlaybackUrl={channel.dashPlaybackUrl}
                isReady={isReady}
                isDrm={isDrm()}
                isVod={isVod()}
                lowLatency={lowLatency}
                fakeLiveLayout={false}
                playerProblemHandler={playerProblemHandler}
                ignoreChrome105VjsFix={event.ignoreChrome105VjsFix === true}
                isEmbed={true}
                manualTriggerControl={customConfig.manualTriggerControl}
                userActiveHandler={userActiveHandler}
                userInactiveHandler={userInactiveHandler}
              ></Player>
            </div>
          )}
        </main>
      )}
    </Fragment>
  );
}
